import { render, staticRenderFns } from "./monkeyKing.vue?vue&type=template&id=68d71838"
import script from "./monkeyKing.vue?vue&type=script&lang=js"
export * from "./monkeyKing.vue?vue&type=script&lang=js"
import style0 from "./monkeyKing.vue?vue&type=style&index=0&id=68d71838&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports